/** Display limit of the footer character counter for email messages. */
export const EMAIL_MESSAGE_LIMIT = 2000;

/** Display limit of the footer character counter for LinkedIn messages. */
export const LINKEDIN_MESSAGE_LIMIT = 600;
